export default{
    KILO_BYTE: 1024,
    MEGA_BYTE: 1024 * 1024,
    IMG_MAX_BYTE: 10 * 1024 * 1024,
    MAX_FILE_COUNT: 5,
    ITEMS_PER_PAGE : 10,
    STOR_IMG_PATH: "images",
    BOARD_INFO: "board-info",
    BOARD_CONTENT: "board-content",
    FILTER_COLLECTION: "filters",
    TAG_FILTER: "tags",
    YEAR_FILTER: "years",
    ASC: "asc",
    DESC: "desc",
};